import React from "react";
import { Redirect } from "react-router-dom";



//login
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";



//-----------------Findagram---------

import BusinessList from "../FindagramAdmin/AdminPages/BusinessList";
import BusinessDetail from "../FindagramAdmin/AdminPages/BusinessDetail";

import UserList from "../FindagramAdmin/AdminPages/UserList";
import UserDetail from "../FindagramAdmin/AdminPages/UserDetail";

import UserSubscription from "../FindagramAdmin/AdminPages/UserSubscription";

import ResetPassword from "../pages/Authentication/ResetPassword";

import UpdateSubscriptionType from "../FindagramAdmin/AdminPages/UpdateSubscriptionType";
import BlogsList from "../FindagramAdmin/Blogs/BlogsList";
import AddBlogs from "../FindagramAdmin/Blogs/AddBlogs";
import EditBlog from "../FindagramAdmin/Blogs/EditBlog";

const authProtectedRoutes = [


//------------------ Findagram-------------
{ path: "/business-list", component: BusinessList },
{ path: "/business-detail/:businessId", component: BusinessDetail },

{ path: "/user-list", component: UserList },
{ path: "/user-detail/:id", component: UserDetail },

{ path: "/user-subscription", component: UserSubscription },
// { path: "/update-subscription-type/:userId", component: UpdateSubscriptionType },
{ path: "/update-subscription-type/:businessId", component: UpdateSubscriptionType },


{ path: "/blogs-list", component: BlogsList },
{ path: "/add-blog", component: AddBlogs },
{ path: "/update-blog/:blogId", component: EditBlog },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/business-list" />,
  },
];

const publicRoutes = [
    // Authentication Page
    { path: "/logout", component: Logout },
    { path: "/login", component: Login },
    { path: "/forgot-password", component: ForgetPasswordPage },
    { path: "/register", component: Register },
    { path: "/reset-password", component: ResetPassword},
  


];

export { authProtectedRoutes, publicRoutes };